import { buildApiUrl, Type, sendPutRequest } from '../api'
import { type UpdateAssetSettings } from './schemas'
import { objectWithoutKeys, roundToFractionalCurrencyPrecision } from '@/helpers'
import { AssetType } from '@/features/assets/constants'

export async function saveAssetSettings(assetCode: string, settings: Omit<UpdateAssetSettings, 'contacts'|'tariffProfile'>) {
  if (settings.assetType !== AssetType.Wheeling && settings.assetType !== AssetType.Solar) {
    throw new Error('Unexpected asset type when saving settings.')
  }

  const url = buildApiUrl(Type.AssetManagement, `asset/${assetCode}/settings`)

  await sendPutRequest(url, {
    data: {
      ...settings,
      contractTerms: {
        ...objectWithoutKeys(settings.contractTerms, ['firstEscalationMonth', 'firstEscalationYear']),
        firstEscalationMonth: `${settings.contractTerms.firstEscalationYear}-${(settings.contractTerms.firstEscalationMonth).toString().padStart(2, '0')}-01`,
      },
      utilityProvider: {
        ...objectWithoutKeys(settings.utilityProvider, ['blendedTariff']),
        blendedTariffInCents: roundToFractionalCurrencyPrecision(settings.utilityProvider.blendedTariff * 100)
      }
    }
  })
}
